import { getLocalized } from '../locales';
function monthNameBuilder(_a) {
    var format = _a.format, locale = _a.locale;
    var requestedLocale = getLocalized(locale);
    var returnValue = [];
    for (var m = 0; m < 12; m++) {
        returnValue.push(requestedLocale.month(m, { width: format }));
    }
    return returnValue;
}
export default monthNameBuilder;
//# sourceMappingURL=monthNameBuilder.js.map